export const COLLAPSED = Object.freeze({ categories: false, statuses: false });
export const SERVICES_CLOSED = Object.freeze({ open: false, query: "", scroll: 0 });
export const FILTER_RELOAD = "filters";

export function toggleSection(sections, section) {
  return { ...sections, [section]: !sections[section] };
}

export function menuMaxHeight({ top, viewport, margin = 16, min = 240 }) {
  return Math.max(min, Math.floor(viewport - top - margin));
}

export function claimReopen(pending, reason) {
  if (!pending || reason !== FILTER_RELOAD) return { open: false, focusKey: null, sections: COLLAPSED, listScroll: 0, services: SERVICES_CLOSED };
  return { open: true, focusKey: pending.focusKey || null, sections: pending.sections || COLLAPSED, listScroll: pending.listScroll || 0, services: pending.services || SERVICES_CLOSED };
}

export function scrollToShow(item, view) {
  if (item.top < view.top) return item.top - view.top;
  if (item.bottom > view.bottom) return Math.min(item.bottom - view.bottom, item.top - view.top);
  return 0;
}

export function serviceSummary(rows) {
  const shown = rows.filter((row) => row.checked);
  if (shown.length === rows.length) return { label: "All services", active: false };
  if (shown.length === 0) return { label: "No services selected", active: true };
  if (shown.length === 1) return { label: String(shown[0].label).trim(), active: true };
  return { label: `${shown.length} of ${rows.length} services`, active: true };
}

export function serviceMatches(search, query) {
  const needle = String(query).trim().toLowerCase();
  return needle === "" || String(search).includes(needle);
}

export function statusSummary(rows) {
  const indexes = rows.map((row, index) => (row.checked ? index : null)).filter((index) => index !== null);
  if (indexes.length === rows.length) return { label: "All statuses", active: false, shown: [] };
  if (indexes.length === 0) return { label: "No statuses", active: true, shown: [] };
  return { label: indexes.map((index) => String(rows[index].label).trim()).join(", "), active: true, shown: indexes };
}

export function categorySummary(rows) {
  const checked = rows.filter((row) => row.checked).map((row) => String(row.label).trim());
  if (checked.length === 0) return { label: "All statuses & categories", active: false };
  return { label: checked.join(", "), active: true };
}

export function checkedAfterReset(detail, name, value) {
  switch (name) {
    case "lanes":
      return value === detail[name];
    case "service":
      return !detail.hiddenServices.includes(value);
    case "blocks":
    case "schedules":
      return detail[name] === "show";
    case "scheduled":
      return detail.scheduled === "only";
    case "empty":
      return detail.empty === "hide";
    case "category":
      return detail.categories.includes(value);
    case "status":
      return !detail.hiddenStatuses.includes(value);
    default:
      return null;
  }
}

export function facilitySelection(options, value) {
  const picked = options.find((option) => option.value === value);
  if (!picked) return null;
  return { selected: options.map((option) => option === picked), label: String(picked.label).trim() };
}

export function showAllFocusKey(open, firstRowKey) {
  return open && firstRowKey ? firstRowKey : "statuses-summary";
}
